import React from 'react';
import PropTypes from 'prop-types';

export var DormifyLogo = function DormifyLogo(props) {
  return React.createElement(
    'svg',
    {
      className: 'dormify-logo',
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 131.4 41.7'
    },
    React.createElement('path', {
      strokeWidth: '1.3',
      stroke: props.color || '#e83a9f',
      fill: 'none',
      strokeLinecap: 'round',
      strokeDasharray: '150',
      d: 'M12.4 26.6c-3.1 0-5.6-2.7-5.6-6.1s2.5-6.2 5.6-6.2 5.6 2.8 5.6 6.2-2.6 6.1-5.6 6.1zM18 13.7c-1.2-1.4-3.2-2.6-5.6-2.6-5 0-9 4.2-9 9.5 0 5.2 4 9.3 9 9.3 2.5 0 4.5-1.3 5.7-2.7v2.3h3.3V3.8H18v9.9zM32.7 26.7c-3.1 0-5.6-2.8-5.6-6.1 0-3.5 2.5-6.3 5.6-6.3 3.1 0 5.6 2.8 5.6 6.3 0 3.4-2.5 6.1-5.6 6.1m0-15.6c-5.1 0-9 4.2-9 9.5 0 5.2 4 9.3 9 9.3 5.1 0 9-4.1 9-9.3.1-5.3-3.9-9.5-9-9.5m19.5 0c-1.9 0-3.5.7-4.8 1.9v-1.5h-3.3v18h3.4V18.6c0-2.5 1.8-4.3 4.3-4.3s4 1.7 4 4.4v1.6h3.4v-1.5c-.1-4.7-2.8-7.7-7-7.7m27.6 0c-2.3 0-4.2 1-5.4 2.7-1.2-1.8-3-2.7-5.4-2.7-1.7 0-3.2.7-4.4 1.9v-1.5h-3.3v18h3.4V18.6c0-2.4 1.7-4.3 3.8-4.3 2.3 0 3.6 1.4 3.6 4.1v11.1h3.4V18.6c0-2.5 1.6-4.3 3.8-4.3 3 0 3.7 2.2 3.7 4.1v11.1h3.4V18.4c.2-4.5-2.4-7.3-6.6-7.3m9.5-1.6h3.4v-4h-3.4v4zm0 20h3.4v-18h-3.4v18zm14.1-24c-4.4 0-7.6 3.2-7.6 7.6v16.4h3.4v-8.7h11.7v-3.3H99.2v-4.4c0-2.5 1.7-4.3 4.2-4.3s4.2 1.8 4.2 4.3V15h3.4v-1.9c0-4.4-3.2-7.6-7.6-7.6m21.4 6v10.8c0 2.5-1.7 4.2-4.1 4.2-2.5 0-4.2-1.7-4.2-4.2V11.5h-3.4v10.8c0 4.4 3.2 7.5 7.5 7.5 1.7 0 3-.5 4.1-1.4v2c0 2.6-1.6 4.2-4.1 4.2-2 0-3.4-1-4-2.8l-.1-.2h-3.4l.1.3c.7 3.6 3.6 6 7.4 6 4.5 0 7.5-3 7.5-7.5v-19l-3.3.1z'
    })
  );
};

DormifyLogo.propTypes = {
  color: PropTypes.string
};

var _ref = React.createElement(
  'svg',
  {
    version: '1.1',
    className: 'icon icon-close',
    xmlns: 'http://www.w3.org/2000/svg',
    x: '0px',
    y: '0px',
    viewBox: '0 0 14 14'
  },
  React.createElement('line', {
    fill: 'none',
    stroke: '#545658',
    strokeMiterlimit: '10',
    x1: '13.1',
    y1: '0.9',
    x2: '1.1',
    y2: '12.9'
  }),
  React.createElement('line', {
    fill: 'none',
    stroke: '#545658',
    strokeMiterlimit: '10',
    x1: '13.1',
    y1: '12.9',
    x2: '1.1',
    y2: '0.9'
  })
);

export var IconCloseWithCircle = function IconCloseWithCircle(props) {
  return React.createElement(
    'button',
    Object.assign({ className: 'IconCloseWithCircle' }, props),
    _ref
  );
};

var _ref2 = React.createElement(
  'svg',
  {
    version: '1.1',
    className: 'icon icon-close',
    xmlns: 'http://www.w3.org/2000/svg',
    x: '0px',
    y: '0px',
    viewBox: '0 0 14 14'
  },
  React.createElement('line', {
    fill: 'none',
    stroke: '#545658',
    strokeMiterlimit: '10',
    x1: '13.1',
    y1: '0.9',
    x2: '1.1',
    y2: '12.9'
  }),
  React.createElement('line', {
    fill: 'none',
    stroke: '#545658',
    strokeMiterlimit: '10',
    x1: '13.1',
    y1: '12.9',
    x2: '1.1',
    y2: '0.9'
  })
);

export var IconClose = function IconClose() {
  return _ref2;
};

export var BtnArrow = function BtnArrow(props) {
  return React.createElement(
    'svg',
    { className: 'icon btn-arrow', width: '20', viewBox: '0 0 26 9.3' },
    React.createElement('path', {
      fill: props.color || '#223746',
      d: 'M21.4 0l-.8.7 3.5 3.4H0v1h24.1l-3.5 3.5.8.7L26 4.6z'
    })
  );
};

BtnArrow.propTypes = {
  color: PropTypes.string
};

export var IconArrow = function IconArrow(props) {
  return React.createElement(
    'svg',
    {
      className: 'icon icon-arrow',
      version: '1',
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 8 13.7'
    },
    React.createElement('path', {
      fill: props.color || '#a6a5a5',
      d: 'M.8 13.7l-.8-.9 6.3-5.9L0 .9.8 0 8 6.9z'
    })
  );
};

IconArrow.propTypes = {
  color: PropTypes.string
};

export var IconCheck = function IconCheck(props) {
  return React.createElement(
    'svg',
    {
      className: 'icon icon-check',
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 9.9 8.6'
    },
    React.createElement('path', {
      fill: 'none',
      stroke: props.stroke || '#e83a9f',
      strokeWidth: '1.5',
      strokeMiterlimit: '10',
      d: 'M.6 4.2l3 3.3 5.7-7'
    })
  );
};

IconCheck.propTypes = {
  stroke: PropTypes.string
};

var _ref3 = React.createElement(
  'svg',
  {
    className: 'icon icon-cart',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 23.3 17.9'
  },
  React.createElement('path', {
    d: 'M5.7 4.8l16.6-.2-2.3 9H7.9L4.5.8H0',
    fill: 'none',
    stroke: '#221f20',
    strokeWidth: '1.3'
  }),
  React.createElement('path', {
    className: 'tires',
    d: 'M9.8 16.4c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5c.8-.1 1.5.6 1.5 1.5m10.1-1.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5',
    fill: '#221f20'
  })
);

export var IconCart = function IconCart() {
  return _ref3;
};

var _ref4 = React.createElement(
  'svg',
  {
    className: 'icon icon-account',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 11.8 17.5'
  },
  React.createElement('path', {
    fill: '#FEFEFE',
    d: 'M9.3 4.1c0 1.9-1.5 3.4-3.4 3.4-2 0-3.5-1.5-3.5-3.4S3.9.7 5.8.7c1.9.1 3.5 1.6 3.5 3.4'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#221f20',
    strokeWidth: '1.2',
    d: 'M9.3 4.1c0 1.9-1.5 3.4-3.4 3.4-2 0-3.5-1.5-3.5-3.4S3.9.7 5.8.7c1.9.1 3.5 1.6 3.5 3.4z'
  }),
  React.createElement('path', {
    fill: '#FEFEFE',
    d: 'M11 16.7c0-3.6-.4-7.1-4.8-7.1h-.6C1.3 9.6.8 13.1.8 16.7H11z'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#221f20',
    strokeWidth: '1.2',
    d: 'M11 16.7c0-3.6-.4-7.1-4.8-7.1h-.6C1.3 9.6.8 13.1.8 16.7H11z'
  })
);

export var IconAccount = function IconAccount() {
  return _ref4;
};

var _ref5 = React.createElement(
  'svg',
  { className: 'icon icon-minus', width: '5', viewBox: '0 0 8 2' },
  React.createElement('path', { fill: '#213746', d: 'M0 0h8v2H0z' })
);

export var IconMinus = function IconMinus() {
  return _ref5;
};

var _ref6 = React.createElement(
  'svg',
  { className: 'icon icon-plus', width: '5', viewBox: '0 0 10 10' },
  React.createElement('path', { d: 'M6 4h4v2H6v4H4V6H0V4h4V0h2v4z', fill: '#213746' })
);

export var IconPlus = function IconPlus() {
  return _ref6;
};

var _ref7 = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    className: 'icon icon-plus-minus',
    width: '20',
    height: '20',
    viewBox: '0 0 160 160'
  },
  React.createElement('rect', {
    className: 'vertical-line',
    x: '70',
    width: '20',
    height: '160',
    fill: '#747474'
  }),
  React.createElement('rect', {
    className: 'horizontal-line',
    y: '70',
    width: '160',
    height: '20',
    fill: '#747474'
  })
);

export var IconPlusMinus = function IconPlusMinus() {
  return _ref7;
};

var _ref8 = React.createElement(
  'svg',
  {
    className: 'icon icon-crossedout',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 19.7 18.7'
  },
  React.createElement('path', { d: 'M.3 18.4l19-18', fill: 'none', stroke: '#a6a6a6' })
);

export var IconCrossedout = function IconCrossedout() {
  return _ref8;
};

var _ref9 = React.createElement(
  'svg',
  {
    className: 'icon icon-dormify-exclusive',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 22.1 21'
  },
  React.createElement('path', {
    d: 'M17.7 5.5v10.9h-1.2v-1.2c-.5.8-1.5 1.4-2.7 1.4-2.2 0-3.8-1.8-3.8-3.9 0-2.2 1.6-4 3.9-4 1.1 0 2.1.6 2.6 1.3V5.5h1.2zm-1.4 7.2c0-1.5-1.2-2.8-2.6-2.8-1.5 0-2.6 1.2-2.6 2.8 0 1.5 1.1 2.7 2.6 2.7 1.4.1 2.6-1.2 2.6-2.7z',
    fill: '#e83a9f'
  }),
  React.createElement('path', { d: 'M.5.5h21.1v20H.5V.5z', fill: 'none', stroke: '#221f20' })
);

export var IconDormifyExclusive = function IconDormifyExclusive() {
  return _ref9;
};

var _ref10 = React.createElement(
  'svg',
  {
    className: 'icon icon-free-shipping',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 31.3 33.2'
  },
  React.createElement('path', {
    fill: 'none',
    stroke: '#231f20',
    strokeWidth: '1.5',
    strokeMiterlimit: '10',
    d: 'M30.3 6.9L15.7 13M.9 6.7L15.7 13m0 0v19.4'
  }),
  React.createElement('path', { d: 'M.1 0h31.2v33.2H.1V0z', fill: 'none' }),
  React.createElement('path', {
    d: 'M23.6 15.6c-.6.2-1.1.3-1.1-.2V10L8.3 4.3l2.4-1 13.1 5.2c.4.1.6.5.6.9V15c0 .4-.2.4-.8.6',
    fill: '#e14096'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#231f20',
    strokeWidth: '1.5',
    strokeMiterlimit: '10',
    d: 'M30.5 7.7c0-.9-.3-1.3-1.1-1.6-4.3-1.7-8.6-3.4-12.9-5.2-.6-.2-1.1-.2-1.7 0-4.3 1.8-8.6 3.5-12.9 5.2-.4.2-1 .3-1.1.7v19.6c-.1.3 15.1 6 15.1 6s10.5-4.2 13.4-5.4c.8-.3 1.2-.7 1.2-1.7V7.7z'
  })
);

export var IconFreeShipping = function IconFreeShipping() {
  return _ref10;
};

var _ref11 = React.createElement(
  'svg',
  {
    className: 'icon icon-ships-separate',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 35.4 28.8'
  },
  React.createElement('path', {
    fill: 'none',
    stroke: '#231f20',
    strokeWidth: '1.5',
    strokeMiterlimit: '10',
    d: 'M20.7 4.9L10.8 9M.8 4.8l10 4.3m0 0v13.1'
  }),
  React.createElement('path', {
    fill: '#e14096',
    d: 'M16.2 10.8c-.4.1-.7.2-.7-.1V7L5.8 3.2l1.6-.7L16.3 6c.3.1.4.3.4.6v3.8c0 .3-.1.3-.5.4'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#231f20',
    strokeWidth: '1.5',
    strokeMiterlimit: '10',
    d: 'M20.9 14.4v-9c0-.6-.2-.9-.7-1.1C17.3 3.1 14.4 2 11.5.8c-.4-.1-.7-.1-1.2 0-3 1.3-5.9 2.4-8.8 3.6-.3.1-.7.2-.7.4v13.3c-.1.2 10.2 4.1 10.2 4.1l5.5-2.4M34.6 16.5l-8.9 3.7m-9.1-3.8l9 3.9m0-.1V28'
  }),
  React.createElement('path', {
    fill: '#e14096',
    d: 'M30.5 21.8c-.4.1-.7.2-.7-.1v-3.3l-8.7-3.5 1.5-.6 8 3.2c.2.1.4.3.4.6v3.4c-.1.2-.2.2-.5.3'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#231f20',
    strokeWidth: '1.5',
    strokeMiterlimit: '10',
    d: 'M34.7 17c0-.6-.2-.8-.7-1-2.6-1-5.3-2.1-7.9-3.2-.4-.1-.7-.1-1 0-2.6 1.1-5.3 2.1-7.9 3.2-.2.1-.6.2-.7.4v8c-.1.2 9.2 3.7 9.2 3.7s6.4-2.6 8.2-3.3c.5-.2.7-.4.7-1 .1-.1.1-6.8.1-6.8z'
  })
);

export var IconShipsSeparate = function IconShipsSeparate() {
  return _ref11;
};

var _ref12 = React.createElement(
  'svg',
  {
    className: 'icon icon-return',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 21.9 14.3'
  },
  React.createElement(
    'g',
    { transform: 'translate(-188 -3)' },
    React.createElement(
      'g',
      { transform: 'translate(188 3)' },
      React.createElement('path', {
        fill: 'none',
        stroke: '#221f20',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        d: 'M.9 4.8H17c2.4 0 4.4 2 4.4 4.5s-2 4.5-4.4 4.5h-5.5'
      }),
      React.createElement('path', {
        fill: 'none',
        stroke: '#221f20',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        d: 'M4.9 9.3L.5 4.9 4.9.5'
      })
    )
  )
);

export var IconReturn = function IconReturn() {
  return _ref12;
};

var _ref13 = React.createElement(
  'svg',
  {
    className: 'icon icon-ship-to-school',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 35 32.1'
  },
  React.createElement('path', {
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    stroke: '#231f20',
    fill: 'none',
    strokeMiterlimit: '10',
    d: 'M2.3 12.8v11.8h8.3M13.2 7H2.4L1 12.8h10.5m12.8 11.8h8.3V12.8m-9.1 0h10.1l-2-5.8h-10'
  }),
  React.createElement('path', {
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    stroke: '#231f20',
    fill: 'none',
    strokeMiterlimit: '10',
    d: 'M10 10l7.5-6.5L25 10H10z'
  }),
  React.createElement('path', {
    d: 'M11.5 10.1v12.6m12-12.6v12.6',
    fill: 'none',
    stroke: '#231f20',
    strokeWidth: '1.022',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeMiterlimit: '10'
  }),
  React.createElement('path', {
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    stroke: '#231f20',
    fill: 'none',
    strokeMiterlimit: '10',
    d: 'M23.5 22.7l1.6 3.9H9.9l1.6-3.9h12z'
  }),
  React.createElement('circle', { cx: '55.2', cy: '27.7', r: '.1', fill: '#e14096' }),
  React.createElement('circle', {
    stroke: '#e14096',
    fill: 'none',
    strokeMiterlimit: '10',
    cx: '17.5',
    cy: '16.4',
    r: '4.5'
  }),
  React.createElement('path', {
    stroke: '#e14096',
    fill: 'none',
    strokeMiterlimit: '10',
    d: 'M17.5 13.8v2.8l1.5 1.3'
  })
);

export var IconShipsToSchool = function IconShipsToSchool() {
  return _ref13;
};

var _ref14 = React.createElement(
  'svg',
  {
    className: 'icon icon-heart',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 13.7 11.4'
  },
  React.createElement('path', {
    d: 'M6.9 10.9C2.8 9 1 5.6 1 5.6.1 3.8.4 1.7 2.2.9 3.9 0 6 .7 6.9 2.4 7.8.7 9.9 0 11.6.8c1.8.9 2.1 3 1.2 4.7 0 .1-1.8 3.5-5.9 5.4z',
    fill: 'none',
    stroke: '#747474'
  })
);

export var IconHeart = function IconHeart() {
  return _ref14;
};

var _ref15 = React.createElement(
  'svg',
  {
    className: 'icon icon-material',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 14.3 14.8'
  },
  React.createElement('path', { d: 'M10.7 14.3H.5v-11h7.7', fill: 'none', stroke: '#747474' }),
  React.createElement('circle', { cx: '11', cy: '11.5', r: '2.8', fill: 'none', stroke: '#747474' }),
  React.createElement('circle', { cx: '11', cy: '11.5', r: '1.3', fill: 'none', stroke: '#747474' }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    d: 'M13.8 11.5V3.3c0-1.5-1.2-2.8-2.8-2.8S8.2 1.8 8.2 3.3v8.2'
  })
);

export var IconMaterial = function IconMaterial() {
  return _ref15;
};

var _ref16 = React.createElement(
  'svg',
  {
    className: 'icon icon-care',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 19.5 14.1'
  },
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    d: 'M10.1 5.7c-2.1-.9-3-2.6-3-2.6-.5-.9-.3-2 .6-2.4.9-.4 2-.1 2.4.8.5-.9 1.5-1.2 2.4-.8.9.4 1.1 1.5.6 2.4 0 0-.9 1.7-3 2.6zM.1 8.5L5.8 7l8.1 1.2s.7.1.7.7c0 .5-.3.9-2.2.8s-4.8-.2-4.8-.2'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    d: 'M.4 12.8l3-.9s9 1.7 9.1 1.7c.1 0 4.9-2.6 4.9-2.6s1.8-.8 1.5-1.6c-.3-.7-1.1-.4-2.8.2l-3.3 1.2-4.1-1.3'
  })
);

export var IconCare = function IconCare() {
  return _ref16;
};

var _ref17 = React.createElement(
  'svg',
  {
    className: 'icon icon-size',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 13.2 13.2'
  },
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    d: 'M5.5 7.7L.8 12.4M4.9 12.7H.5V8.3M7.7 5.5L12.4.8M8.3.5h4.4v4.4'
  })
);

export var IconSize = function IconSize() {
  return _ref17;
};

var _ref18 = React.createElement(
  'svg',
  {
    className: 'icon icon-expert-tips',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 20 20'
  },
  React.createElement('path', {
    d: 'M5 10c0-2.7 2.2-5 5-5s5 2.2 5 5c0 2.5-2.3 3-2.3 5.4H7.2C7.2 13 5 12.6 5 10z',
    fill: 'none',
    stroke: '#747474',
    strokeWidth: '1.008'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    strokeLinecap: 'round',
    d: 'M7.3 17.5h5.2'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    strokeWidth: '.916',
    strokeLinecap: 'round',
    d: 'M8 19.5h4'
  }),
  React.createElement('path', {
    fill: 'none',
    stroke: '#747474',
    strokeLinecap: 'round',
    d: 'M4.4 5.3L2.8 3.7M15.6 5.2l1.7-1.7M12.5 2.6l.9-2.2M8.2 2.6l-.9-2'
  })
);

export var IconExpertTips = function IconExpertTips() {
  return _ref18;
};

var _ref19 = React.createElement(
  'svg',
  {
    className: 'icon icon-featured',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 14.09 14.09'
  },
  React.createElement('path', { fill: '#e34599', d: 'M0 0h14.09v14.09H0z' }),
  React.createElement('path', {
    fill: '#fff',
    d: 'M7.04 1.82l1.3 3.99h4.2l-3.4 2.47 1.3 3.99-3.4-2.47-3.39 2.47 1.3-3.99-3.4-2.47h4.2l1.29-3.99z'
  })
);

export var IconFeatured = function IconFeatured() {
  return _ref19;
};

var _ref20 = React.createElement(
  'svg',
  {
    className: 'icon icon-arrow-down',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 13.68 7.08'
  },
  React.createElement('path', {
    fill: 'none',
    stroke: '#231f20',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '1.3',
    d: 'M13.03.65L6.84 6.43.65.65'
  })
);

export var IconArrowDown = function IconArrowDown() {
  return _ref20;
};

var _ref21 = React.createElement(
  'svg',
  {
    className: 'icon icon-info',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 16 16'
  },
  React.createElement('circle', {
    cx: '8',
    cy: '8',
    r: '7.5',
    fill: 'none',
    stroke: '#e83a9f',
    strokeMiterlimit: '10'
  }),
  React.createElement('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#e83a9f',
    d: 'M7.1 4.6c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9-.9-.4-.9-.9M7.3 6.9h1.4V12H7.3z'
  })
);

export var IconInfo = function IconInfo() {
  return _ref21;
};

var _ref22 = React.createElement(
  'svg',
  {
    width: '43',
    height: '55',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  },
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M4.279 2.441a2.84 2.84 0 0 0-2.837 2.837v44.504a2.84 2.84 0 0 0 2.837 2.837h34.186a2.84 2.84 0 0 0 2.837-2.837V5.278a2.84 2.84 0 0 0-2.837-2.837H4.279zm34.186 51.62H4.279a4.284 4.284 0 0 1-4.28-4.279V5.278A4.284 4.284 0 0 1 4.28 1h34.186a4.283 4.283 0 0 1 4.278 4.278v44.504a4.284 4.284 0 0 1-4.278 4.28z',
      fill: '#FEFEFE'
    }),
    React.createElement('path', {
      d: 'M9.465 30.827a.748.748 0 0 1-.597-.296l-2.721-3.579a.75.75 0 0 1 1.194-.909L9.58 28.99l6.487-5.574a.75.75 0 0 1 .978 1.138l-7.091 6.093a.752.752 0 0 1-.49.181M35.999 27.384H22.162a.75.75 0 0 1 0-1.5h13.837a.75.75 0 0 1 0 1.5M9.465 45.827a.748.748 0 0 1-.597-.296l-2.721-3.579a.75.75 0 0 1 1.194-.909L9.58 43.99l6.487-5.574a.75.75 0 0 1 .978 1.138l-7.091 6.093a.752.752 0 0 1-.49.181M35.999 42.384H22.162a.75.75 0 0 1 0-1.5h13.837a.75.75 0 0 1 0 1.5M9.465 16.827a.748.748 0 0 1-.597-.296l-2.721-3.58a.75.75 0 1 1 1.194-.908L9.58 14.99l6.487-5.574a.75.75 0 0 1 .978 1.138l-7.091 6.093a.752.752 0 0 1-.49.181M35.999 13.384H22.162a.75.75 0 0 1 0-1.5h13.837a.75.75 0 0 1 0 1.5',
      fill: '#FEFEFE'
    })
  )
);

export var IconChecklist = function IconChecklist() {
  return _ref22;
};

var _ref23 = React.createElement(
  'svg',
  {
    className: 'icon icon-checklist',
    width: '14',
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 14 20'
  },
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M3.175 3.175V6.45h7.65V3.175h-1.75v-.55a2.075 2.075 0 1 0-4.15 0v.55h-1.75zM3.5 11.57L6 14l4.5-4.375',
      stroke: '#221f20',
      strokeWidth: '1.2'
    }),
    React.createElement('circle', { fill: '#221f20', cx: '7', cy: '2.625', r: '1' }),
    React.createElement('path', { stroke: '#221f20', strokeWidth: '1.2', d: 'M3 5H.5v14h13V5H11' })
  )
);

export var IconChecklistNav = function IconChecklistNav() {
  return _ref23;
};

var _ref24 = React.createElement(
  'svg',
  {
    version: '1.1',
    id: 'Layer_1',
    xmlns: 'http://www.w3.org/2000/svg',
    x: '0px',
    y: '0px',
    width: '20',
    viewBox: '-3 0 22.5 27.2'
  },
  React.createElement(
    'g',
    null,
    React.createElement('circle', { className: 'st8', cx: '8.83', cy: '9.34', r: '4.47' }),
    React.createElement('path', {
      className: 'st8',
      d: 'M8.83,24.77C0.29,17.36,0.75,8.82,0.75,8.82c0-4.46,3.61-8.07,8.07-8.07s8.07,3.61,8.07,8.07 C17.21,17.11,8.83,24.77,8.83,24.77z'
    })
  )
);

export var IconVisitBlack = function IconVisitBlack() {
  return _ref24;
};

var _ref25 = React.createElement(
  'svg',
  {
    width: '32',
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  },
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M21.887 8.55c2.315 0 4.191-1.914 4.191-4.275 0-2.361-1.876-4.275-4.19-4.275-2.316 0-4.192 1.914-4.192 4.275 0 2.361 1.876 4.275 4.191 4.275M9.78 1.114c1.708 0 3.098 1.418 3.098 3.16 0 1.744-1.39 3.162-3.099 3.162-1.709 0-3.098-1.418-3.098-3.161s1.39-3.16 3.098-3.16m0 7.435c2.315 0 4.192-1.914 4.192-4.275C13.97 1.914 12.094 0 9.779 0 7.465 0 5.59 1.914 5.59 4.275c0 2.361 1.876 4.275 4.19 4.275',
      fill: '#e83a9f'
    }),
    React.createElement('path', {
      d: 'M1.145 17.964c.534-4.176 4.252-7.42 8.744-7.42s8.21 3.244 8.743 7.42H1.145zM31.58 19c0-5.243-4.427-9.493-9.889-9.493-2.211 0-4.253.697-5.9 1.875a10.118 10.118 0 0 0-5.901-1.875C4.427 9.507 0 13.757 0 19h31.58z',
      fill: '#e83a9f'
    })
  )
);

export var IconRoomieShare = function IconRoomieShare() {
  return _ref25;
};

var _ref26 = React.createElement(
  'svg',
  { className: 'icon icon-mobile-nav', viewBox: '0 0 100 100' },
  React.createElement('path', {
    className: 'line top',
    d: 'm 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20'
  }),
  React.createElement('path', { className: 'line middle', d: 'm 30,50 h 40' }),
  React.createElement('path', {
    className: 'line bottom',
    d: 'm 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20'
  })
);

export var IconMobileHamburger = function IconMobileHamburger() {
  return _ref26;
};

var _ref27 = React.createElement(
  'svg',
  {
    className: 'icon icon-back-arrow',
    width: '155',
    height: '125',
    viewBox: '0 0 155 125',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  },
  React.createElement('path', {
    fill: '#FFF',
    fillRule: 'evenodd',
    transform: 'matrix(-1 0 0 1 155.167 0)',
    d: 'M151.158 68.326c.085-.103.16-.212.238-.319.094-.125.19-.247.278-.377.084-.127.158-.257.235-.386.071-.12.145-.235.211-.358.07-.13.13-.266.192-.4.061-.128.125-.255.18-.387.053-.129.096-.26.143-.391.052-.142.106-.282.15-.427.04-.13.068-.262.101-.394.038-.149.08-.296.11-.447.03-.151.046-.303.069-.455.02-.134.044-.266.058-.402a8.9 8.9 0 0 0 .042-.835l.002-.039-.002-.039a8.892 8.892 0 0 0-.042-.834c-.014-.137-.039-.269-.058-.403-.023-.151-.04-.303-.07-.454-.03-.152-.071-.3-.109-.448-.033-.131-.062-.263-.101-.393-.044-.145-.098-.285-.15-.427-.047-.131-.09-.263-.143-.392-.055-.132-.119-.259-.18-.387-.063-.134-.122-.269-.192-.4-.066-.122-.14-.239-.211-.357-.077-.13-.15-.26-.235-.386-.087-.13-.184-.253-.278-.378-.079-.107-.153-.216-.238-.319a8.934 8.934 0 0 0-.566-.627c-.008-.007-.014-.015-.02-.022L100.723 6.596a8.862 8.862 0 1 0-12.533 12.532l34.72 34.72H10.86A8.862 8.862 0 0 0 2 62.709a8.862 8.862 0 0 0 8.862 8.862H122.91l-34.72 34.72a8.862 8.862 0 0 0 12.533 12.532l49.847-49.848.02-.022c.2-.2.388-.409.567-.627'
  })
);

export var IconBackArrow = function IconBackArrow() {
  return _ref27;
};

var _ref28 = React.createElement(
  'svg',
  {
    className: 'icon icon-enlarge',
    viewBox: '0 0 23 23',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '25',
    width: '25'
  },
  React.createElement(
    'g',
    { fill: '#221f20', fillRule: 'nonzero' },
    React.createElement('path', { d: 'M0 0h23v23H0V0zm1.21 1.21v20.58h20.58V1.21H1.21z' }),
    React.createElement('path', { d: 'M4.443 18.557v-4.574h-1.22v5.794h5.794v-1.22z' }),
    React.createElement('path', { d: 'M4.265 19.598l5.75-5.75-.863-.863-5.75 5.75zM18.598 4.527V9.1h1.22V3.307h-5.793v1.22z' }),
    React.createElement('path', { d: 'M18.777 3.485l-5.75 5.75.863.863 5.75-5.75z' })
  )
);

export var IconEnlarge = function IconEnlarge() {
  return _ref28;
};

var _ref29 = React.createElement(
  'svg',
  {
    className: 'icon icon-collapse',
    viewBox: '0 0 23 23',
    xmlns: 'http://www.w3.org/2000/svg',
    height: '25',
    width: '25'
  },
  React.createElement(
    'g',
    { fill: '#221f20', fillRule: 'evenodd' },
    React.createElement('path', {
      fillRule: 'nonzero',
      d: 'M0 0h23v23H0V0zm1.21 1.21v20.58h20.58V1.21H1.21z'
    }),
    React.createElement('path', { d: 'M8.574 14.22v4.574h1.22V13H4v1.22z' }),
    React.createElement('path', { d: 'M4.265 19.598l5.49-5.615-.603-.998-5.75 5.75zM14.243 8.882V4.308h-1.219v5.793h5.793V8.882z' }),
    React.createElement('path', { d: 'M18.776 3.486l-5.75 5.75.863.863 5.75-5.75z' })
  )
);

export var IconCollapse = function IconCollapse() {
  return _ref29;
};

var _ref31 = React.createElement('path', { d: 'M15.944 18.108L16.106 9h-1.8l.144 9.108h1.494zm-.738 3.492c.684 0 1.188-.432 1.188-1.116 0-.702-.504-1.134-1.188-1.134-.702 0-1.206.432-1.206 1.134 0 .684.504 1.116 1.206 1.116z' });

var _ref32 = React.createElement('path', { d: 'M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm0 2C7.82 2 2 7.82 2 15s5.82 13 13 13 13-5.82 13-13S22.18 2 15 2z' });

export var IconError = function IconError(_ref30) {
  var fill = _ref30.fill;

  return React.createElement(
    'svg',
    {
      className: 'icon icon-error',
      width: '30',
      height: '30',
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 30 30'
    },
    React.createElement(
      'g',
      { fill: fill || '#d02e2e', fillRule: 'nonzero' },
      _ref31,
      _ref32
    )
  );
};

IconError.propTypes = {
  fill: PropTypes.string
};

var _ref33 = React.createElement(
  'svg',
  {
    className: 'icon icon-exclamation-mark',
    width: '30',
    height: '30',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 30 30'
  },
  React.createElement(
    'g',
    { fill: '#FFFFFF', fillRule: 'nonzero' },
    React.createElement('path', { d: 'M15.944 18.108L16.106 9h-1.8l.144 9.108h1.494zm-.738 3.492c.684 0 1.188-.432 1.188-1.116 0-.702-.504-1.134-1.188-1.134-.702 0-1.206.432-1.206 1.134 0 .684.504 1.116 1.206 1.116z' })
  )
);

export var IconExclamationMark = function IconExclamationMark() {
  return _ref33;
};

var _ref34 = React.createElement(
  'svg',
  {
    width: '21',
    height: '21',
    viewBox: '0 0 21 21',
    xmlns: 'http://www.w3.org/2000/svg',
    className: 'icon-share'
  },
  React.createElement(
    'g',
    { fill: '#EA42A1', fillRule: 'nonzero' },
    React.createElement('path', { d: 'M10.5 16a1 1 0 00.993-.883L11.5 15V1A1 1 0 009.507.883L9.5 1v14a1 1 0 001 1z' }),
    React.createElement('path', { d: 'M15.327 6.74a1 1 0 001.433-1.39l-.087-.09-5.5-5A1 1 0 009.927.18l-.1.08-5.5 5A1 1 0 005.575 6.82l.098-.08 4.826-4.388 4.828 4.389zM5 8.5a1 1 0 01.117 1.993L5 10.5H2V19h17v-8.5h-3a1 1 0 01-.993-.883L15 9.5a1 1 0 01.883-.993L16 8.5h4a1 1 0 01.993.883L21 9.5V20a1 1 0 01-.883.993L20 21H1a1 1 0 01-.993-.883L0 20V9.5a1 1 0 01.883-.993L1 8.5h4z' })
  )
);

export var IconShare = function IconShare() {
  return _ref34;
};

var _ref35 = React.createElement(
  'svg',
  {
    width: '68',
    height: '64',
    viewBox: '0 0 68 64',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd', stroke: '#e83a9f', strokeWidth: '3' },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M2 62V37h59v25M8 37V17h47v20M2 55.5h59'
    }),
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M16 37V25h11v12M36 37V25h11v12'
    }),
    React.createElement('circle', { fill: '#FFF', cx: '55.5', cy: '12.5', r: '11' }),
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M50 12l4 4 7-7M2 46.5h59'
    })
  )
);

export var IconSavedBed = function IconSavedBed() {
  return _ref35;
};

var _ref36 = React.createElement(
  'svg',
  {
    width: '22.3',
    height: '21',
    viewBox: '0 0 68 64',
    xmlns: 'http://www.w3.org/2000/svg',
    className: 'icon-bed'
  },
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd', stroke: '#e83a9f', strokeWidth: '4' },
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M2 62V37h59v25M8 37V17h47v20M2 55.5h59'
    }),
    React.createElement('path', {
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      d: 'M16 37V25h11v12M36 37V25h11v12'
    })
  )
);

export var IconBed = function IconBed() {
  return _ref36;
};

var _ref37 = React.createElement(
  'svg',
  {
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '53',
    height: '50',
    viewBox: '0 0 68 64',
    xmlSpace: 'preserve'
  },
  React.createElement('path', {
    fill: '#e83a9f',
    d: 'M54.94 15.79L33.99 1.76 13.76 15.79H0v46.44h68V15.79H54.94zM34.01 4.98L50.16 15.8H18.43L34.01 4.98zm31.33 13.47v39.01L48.47 39.13l-8.27 9.31L24.31 27 2.66 56.78V18.45h62.68zm-1.73 41.13H3.97l20.37-28.01 15.68 21.15 8.49-9.56 15.1 16.42z'
  }),
  React.createElement('circle', { fill: '#e83a9f', cx: '53.39', cy: '29.29', r: '3.92' })
);

export var IconSavedWall = function IconSavedWall() {
  return _ref37;
};

var _ref38 = React.createElement(
  'svg',
  {
    width: '21',
    height: '21',
    viewBox: '0 0 21 21',
    xmlns: 'http://www.w3.org/2000/svg',
    className: 'icon-save'
  },
  React.createElement(
    'g',
    {
      fill: 'none',
      fillRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      stroke: '#e83a9f',
      strokeWidth: '2'
    },
    React.createElement('path', { d: 'M1 14v6h19v-6M10.5 1v14' }),
    React.createElement('path', { d: 'M5 10l5.5 5 5.5-5' })
  )
);

export var IconSave = function IconSave() {
  return _ref38;
};

var _ref39 = React.createElement(
  'svg',
  {
    className: 'icon icon-twitter',
    width: '20',
    viewBox: '0 0 20 16',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  },
  React.createElement(
    'defs',
    null,
    React.createElement('path', { d: 'M0 0h19.862v15.895H0z' })
  ),
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M17.522 2.514a4.04 4.04 0 0 0 1.791-2.22 8.183 8.183 0 0 1-2.587.972A4.104 4.104 0 0 0 13.752 0C11.5 0 9.676 1.797 9.676 4.013c0 .315.036.62.106.914a11.629 11.629 0 0 1-8.4-4.193 3.95 3.95 0 0 0-.55 2.018c0 1.392.719 2.62 1.812 3.34A4.111 4.111 0 0 1 .798 5.59v.051c0 1.944 1.404 3.566 3.27 3.934a4.113 4.113 0 0 1-1.842.069c.519 1.595 2.024 2.754 3.807 2.787a8.254 8.254 0 0 1-5.061 1.718c-.329 0-.653-.02-.972-.056a11.663 11.663 0 0 0 6.247 1.803c7.495 0 11.594-6.116 11.594-11.418 0-.175-.005-.348-.012-.52a8.2 8.2 0 0 0 2.033-2.077c-.73.32-1.515.536-2.34.633z',
      fill: '#e83a9f'
    })
  )
);

export var IconTwitter = function IconTwitter() {
  return _ref39;
};

var _ref40 = React.createElement(
  'svg',
  {
    className: 'icon icon-facebook',
    width: '20',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  },
  React.createElement(
    'defs',
    null,
    React.createElement('path', { d: 'M0 0h15.98v15.98H0z' })
  ),
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M15.098 0H.882A.882.882 0 0 0 0 .882v14.216c0 .487.395.882.882.882h7.654V9.792H6.453V7.38h2.083V5.601c0-2.064 1.26-3.187 3.101-3.187.882 0 1.64.065 1.861.095v2.157h-1.277c-1.001 0-1.195.476-1.195 1.174v1.54h2.388l-.311 2.412h-2.077v6.188h4.072a.882.882 0 0 0 .882-.882V.882A.882.882 0 0 0 15.098 0',
      fill: '#e83a9f'
    })
  )
);

export var IconFacebook = function IconFacebook() {
  return _ref40;
};

var _ref41 = React.createElement(
  'svg',
  {
    className: 'icon icon-pinterest',
    width: '20',
    viewBox: '0 0 12 15',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  },
  React.createElement(
    'defs',
    null,
    React.createElement('path', { d: 'M0 0h11.885v14.819H0z' })
  ),
  React.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M6.303 0C2.113 0 0 2.9 0 5.318c0 1.463.574 2.766 1.806 3.25.202.08.383.003.441-.212.041-.149.138-.525.18-.683.06-.213.037-.288-.126-.475-.355-.403-.583-.927-.583-1.67 0-2.15 1.669-4.076 4.342-4.076 2.369 0 3.67 1.398 3.67 3.262 0 2.454-1.126 4.527-2.796 4.527-.922 0-1.613-.737-1.392-1.64.265-1.079.779-2.242.779-3.02 0-.697-.388-1.278-1.19-1.278-.943 0-1.7.942-1.7 2.203 0 .803.28 1.347.28 1.347L2.578 11.49c-.336 1.376-.05 3.064-.026 3.235.014.1.149.124.21.049.086-.111 1.21-1.45 1.592-2.787.108-.379.62-2.34.62-2.34.307.565 1.202 1.062 2.154 1.062 2.836 0 4.758-2.494 4.758-5.834C11.885 2.352 9.67 0 6.303 0',
      fill: '#e83a9f'
    })
  )
);

export var IconPinterest = function IconPinterest() {
  return _ref41;
};

var _ref42 = React.createElement(
  'svg',
  {
    width: '23',
    height: '18',
    viewBox: '0 0 23 18',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  React.createElement(
    'g',
    { fill: '#e83a9f', fillRule: 'nonzero' },
    React.createElement('path', { d: 'M21 0H2a2 2 0 00-2 2v13.474a2 2 0 002 2h19a2 2 0 002-2V2a2 2 0 00-2-2zM2 2h19v13.474H2V2z' }),
    React.createElement('path', { d: 'M21.455 1.162a1 1 0 011.184 1.607l-.094.07-10 6.5a1 1 0 01-.976.063l-.114-.064-10-6.5a1 1 0 01.989-1.734l.101.058L12 7.307l9.455-6.145z' })
  )
);

export var IconMail = function IconMail() {
  return _ref42;
};

var _ref43 = React.createElement(
  'svg',
  {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  React.createElement(
    'g',
    { transform: 'translate(1 1)', fill: '#e83a9f', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M22-1H0a1 1 0 00-1 1v15.474l.007.116a1 1 0 00.993.884l9.219-.001 6.793 6.162.086.07c.645.473 1.586.02 1.586-.81v-5.422H22a1 1 0 001-1V0a1 1 0 00-1-1zm-1 2v13.473h-4.316l-.116.007a1 1 0 00-.884.994v4.163l-5.407-4.904-.096-.077a1 1 0 00-.576-.182L1 14.473V1h20z',
      fillRule: 'nonzero'
    }),
    React.createElement('circle', { cx: '5.658', cy: '7.658', r: '1.658' }),
    React.createElement('circle', { cx: '10.5', cy: '7.658', r: '1.658' }),
    React.createElement('circle', { cx: '15.658', cy: '7.658', r: '1.658' })
  )
);

export var IconSms = function IconSms() {
  return _ref43;
};

var _ref44 = React.createElement(
  'svg',
  {
    width: '24',
    height: '27',
    viewBox: '0 0 24 27',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  React.createElement(
    'g',
    { fill: '#e83a9f', fillRule: 'evenodd' },
    React.createElement('path', {
      d: 'M14 4H3a3 3 0 00-3 3v17a3 3 0 003 3h14a3 3 0 003-3V10a1 1 0 00-.293-.707l-5-5A1 1 0 0014 4zm-.415 2L18 10.415V24a1 1 0 01-1 1H3a1 1 0 01-1-1V7a1 1 0 011-1h10.585z',
      fillRule: 'nonzero'
    }),
    React.createElement('path', {
      d: 'M15 20.5a1 1 0 01.117 1.993L15 22.5H5a1 1 0 01-.117-1.993L5 20.5h10z',
      fillRule: 'nonzero'
    }),
    React.createElement('path', { stroke: '#e83a9f', strokeLinejoin: 'round', d: 'M14 5v5h5z' }),
    React.createElement('path', {
      d: 'M15 16.5a1 1 0 01.117 1.993L15 18.5H5a1 1 0 01-.117-1.993L5 16.5h10zM12 12.5a1 1 0 01.117 1.993L12 14.5H5a1 1 0 01-.117-1.993L5 12.5h7z',
      fillRule: 'nonzero'
    }),
    React.createElement('path', {
      d: 'M21 0H7a3 3 0 00-3 3v2l.007.117A1 1 0 005 6h8.585L18 10.415V22a1 1 0 001 1h2a3 3 0 003-3V3a3 3 0 00-3-3zM7 2h14a1 1 0 011 1v17l-.007.117A1 1 0 0121 21h-1V10a1 1 0 00-.293-.707l-5-5-.099-.087A1 1 0 0014 4H6V3a1 1 0 011-1z',
      fillRule: 'nonzero'
    })
  )
);

export var IconCopy = function IconCopy() {
  return _ref44;
};

var _ref45 = React.createElement(
  'svg',
  { viewBox: '0 0 438.529 438.529' },
  React.createElement('path', {
    fill: '#FFFFFF',
    d: 'M417.689 75.654c-1.711-1.709-3.901-2.568-6.563-2.568h-88.224L302.917 25.41c-2.854-7.044-7.994-13.04-15.413-17.989C280.078 2.473 272.556 0 264.945 0h-91.363c-7.611 0-15.131 2.473-22.554 7.421-7.424 4.949-12.563 10.944-15.419 17.989l-19.985 47.676h-88.22c-2.667 0-4.853.859-6.567 2.568-1.709 1.713-2.568 3.903-2.568 6.567v18.274c0 2.664.855 4.854 2.568 6.564 1.714 1.712 3.904 2.568 6.567 2.568H54.81v271.8c0 15.803 4.473 29.266 13.418 40.398 8.947 11.139 19.701 16.703 32.264 16.703h237.542c12.566 0 23.319-5.756 32.265-17.268 8.945-11.52 13.415-25.174 13.415-40.971V109.627h27.411c2.662 0 4.853-.856 6.563-2.568 1.708-1.709 2.57-3.9 2.57-6.564V82.221c.002-2.664-.861-4.854-2.569-6.567zM169.301 39.678c1.331-1.712 2.95-2.762 4.853-3.14h90.504c1.903.381 3.525 1.43 4.854 3.14l13.709 33.404h-127.91l13.99-33.404zm177.872 340.613c0 4.186-.664 8.042-1.999 11.561-1.334 3.518-2.717 6.088-4.141 7.706-1.431 1.622-2.423 2.427-2.998 2.427H100.493c-.571 0-1.565-.805-2.996-2.427-1.429-1.618-2.81-4.188-4.143-7.706-1.331-3.519-1.997-7.379-1.997-11.561V109.627h255.815v270.664z'
  }),
  React.createElement('path', {
    fill: '#FFFFFF',
    d: 'M137.04 347.172h18.271c2.667 0 4.858-.855 6.567-2.567 1.709-1.718 2.568-3.901 2.568-6.57V173.581c0-2.663-.859-4.853-2.568-6.567-1.714-1.709-3.899-2.565-6.567-2.565H137.04c-2.667 0-4.854.855-6.567 2.565-1.711 1.714-2.568 3.904-2.568 6.567v164.454c0 2.669.854 4.853 2.568 6.57 1.713 1.711 3.9 2.567 6.567 2.567zM210.129 347.172H228.4c2.666 0 4.856-.855 6.564-2.567 1.718-1.718 2.569-3.901 2.569-6.57V173.581c0-2.663-.852-4.853-2.569-6.567-1.708-1.709-3.898-2.565-6.564-2.565h-18.271c-2.664 0-4.854.855-6.567 2.565-1.714 1.714-2.568 3.904-2.568 6.567v164.454c0 2.669.854 4.853 2.568 6.57 1.712 1.711 3.903 2.567 6.567 2.567zM283.22 347.172h18.268c2.669 0 4.859-.855 6.57-2.567 1.711-1.718 2.562-3.901 2.562-6.57V173.581c0-2.663-.852-4.853-2.562-6.567-1.711-1.709-3.901-2.565-6.57-2.565H283.22c-2.67 0-4.853.855-6.571 2.565-1.711 1.714-2.566 3.904-2.566 6.567v164.454c0 2.669.855 4.853 2.566 6.57 1.718 1.711 3.901 2.567 6.571 2.567z'
  })
);

export var IconTrash = function IconTrash() {
  return _ref45;
};